// components/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("accessToken"); // or use auth context

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
